import HCRender from "aldoo-ra/HelpCenter/hc-render"
import Typography from "aldoo-ra/Typography"
import TextBundle from "aldoo-ra/CMS/text-bundle"

const Header = ({ searchState, onSearchResultSelect, isHomePage }) => {
  const Search = HCRender.getFragment("Search")
  const texts = TextBundle({ id: "help-center" })

  return (
    <div className="header-container w-full">
      <div className="relative w-full max-w-w2_xl md:h-[290px] rounded-[30px] md:rounded-[50px] bg-gradient-to-br from-primary/30 via-secondary/20 to-primary_lt/40 border border-primary/10 mt-6 md:mt-12 mx-auto">
        <div className="relative w-full h-full flex flex-col items-center justify-center z-20 px-6 py-10 mx-auto">
          <Typography
            variant="h1"
            // the page's heading on the home only; an article or category has its own
            component={isHomePage ? "h1" : "p"}
            className="2xl:!text-[72px] text-text text-center mb-8"
          >
            {texts?.header_title || "How can we help you?"}
          </Typography>
          
          {Search && (
            <Search searchState={searchState} onResultSelect={onSearchResultSelect} />
          )}
        </div>
      </div>
    </div>
  )
}

export default Header
